<template>
    <div class="row" id="events-index">
        <div class="col-12">
            <card>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">
                        <div>
                            <fg-input
                                placeholder="Search..."
                                addon-right-icon="now-ui-icons ui-1_zoom-bold"/>
                        </div>
                        <drop-down
                            tag="li"
                            position="right"
                            title="All Events">
                                <a class="dropdown-item" href="#">Upcoming Events</a>
                                <a class="dropdown-item" href="#">Ongoing Events</a>
                                <a class="dropdown-item" href="#">Past Events</a>
                        </drop-down>
                    </div>
                    <router-link v-if="user.admin" :to="{ name: 'events-create' }">
                        <n-button
                            type="primary"
                            class="no-margin">
                                New
                        </n-button>
                    </router-link>
                </div>
            </card>
        </div>
        <div
            v-if="loading"
            class="col-12 mt-5"
            v-loading="true"></div>
        <div v-else class="col-12">
            <div class="row">
                <div
                    v-for="(event, index) in events"
                    :key="`event-${index}`"
                    class="col-md-3">
                        <card
                            v-loading="event.loading"
                            :data-loading="event.loading"
                            class="event">
                                <div>
                                    <el-dropdown
                                        trigger="click"
                                        @command="performAction">
                                            <span class="el-dropdown-link">
                                                <el-button size="mini">
                                                    <fa :icon="['fas', 'ellipsis-v']"/>
                                                </el-button>
                                            </span>
                                            <el-dropdown-menu slot="dropdown" v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editRegistrationTypes)">
                                                <el-dropdown-item :command="`duplicate-${index}`">Duplicate</el-dropdown-item>
                                                <el-dropdown-item :command="`duplicatewithreg-${index}`">Duplicate With Registrants</el-dropdown-item>
                                                <el-dropdown-item :command="`delete-${index}`">Delete</el-dropdown-item>
                                            </el-dropdown-menu>
                                    </el-dropdown>
                                    <h6 class="text-center">{{ event.name }}</h6>
                                    <div class="d-flex justify-content-center">
                                        <img
                                            v-if="event.logo && event.logo._id"
                                            :src="$store.state.baseUrl + event.logo.path"
                                            width="90px"
                                            height="90px"
                                            style="object-fit: cover"/>
                                    </div>
                                    <!--p>{{ event.description }}</p-->
                                    <p data-content="date">{{ event.startDate | date }} to {{ event.endDate | date }}</p>
                                    <div class="d-flex justify-content-end">
                                        <router-link :to="{ name: 'dashboard', params: { eventId: event._id } }">
                                            <el-button class="btn btn-neutral" data-action="more">
                                                More
                                            </el-button>
                                        </router-link>
                                    </div>
                                </div>
                        </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import http from '../../http.js'
import swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: false,
            events: []
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    mounted () {
        this.getEvents()
    },
    methods: {
        getEvents: async function () {
            try {
                this.loading = true
                const response = await this.$store.dispatch('getAll', { path: 'events' })
                this.events = response.data.events
            } catch (e) {
                console.log('error getting events')
            }
            this.loading = false
        },
        performAction: function (command) {
            command = command.split('-')
            const event = this.events[command[1]]

            switch (command[0]) {
                case 'duplicate':
                    this.clone(command[1], event._id)
                    break
                case 'duplicatewithreg':
                    this.clone(command[1], event._id, true)
                    break
                case 'delete':
                    this.deleteEvent(command[1], event._id)
                    break
            }
        },
        clone: async function (index, id, registrants=false) {
            this.$set(this.events[index], 'loading', true)
            try {
                const response = await http.post(`/api/events/${id}/clone`, {
                    ...(registrants && {
                        withRegistrants: true
                    })
                })
                this.$notify('New event was successfully created!')
                this.events.push(response.data.event)
            } catch (e) {
                console.log(e)
                console.log('error cloning event')
                this.$store.dispatch('handleErrors', e)
            }
            this.$set(this.events[index], 'loading', false)
        },
        deleteEvent: async function (index, id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the event ? All information related to event will be deleted!`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.$set(this.events[index], 'loading', true)
                    await this.$store.dispatch('remove', { path: 'events', id })
                    this.events = this.events.filter(event => event._id !== id)
                    this.$notify('Successfully deleted!')
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting speaker')
            }
        }
    },
    filters: {
        date: (value) => moment(value).format('MMMM DD, YYYY')
    }
}
</script>

<style lang="sass">
#events-index
    .event.card
        height: 223px

        .card-body
            height: 100%
            display: flex
            align-items: center
            justify-content: center
            padding-bottom: 30px

        p
            margin: 0
            text-align: center

            &[data-content="date"]
                margin-top: 10px
                font-size: 12px
                color: #333333

        .el-dropdown
            position: absolute
            top: 10px
            right: 15px

        button[data-action="more"]
            position: absolute
            margin: 0
            bottom: 10px
            right: 5px

        &[data-loading="true"]
            &::after
                content: ''
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%
                background-color: white
                opacity: .7
                z-index: 2
</style>